import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Modal, Paper, Select, Typography } from "@material-ui/core";
import { getPricingVisualizer } from "../../../Actions";
import { CalculationVisualizerContext } from "../../../Context/CalculationVisualizerContextProvider";
import { useContext, useEffect, useState } from "react";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { ExpandMore } from "@material-ui/icons";

export default function FlowModal (props) {
  const { isPromoFlow, setIsPromoFlow, selectedOrientation } = useContext(CalculationVisualizerContext);
  const [nodes, setNodes] = useState([]);
  // const [edges, setEdges] = useState([]);
  // const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(props?.roleId || "");
  const [productUUID, setProductUUID] = useState(props?.productUUID || "");
  const [selectedOption, setSelectedOption] = useState(props.options[0] || null);
  const [isPromoFlowAvailable, setIsPromoFlowAvailable] = useState(false);

  async function getDataWithCalculations(productUUID, selectedRole, selectedOption, selectedOrientation) {
    await getPricingVisualizer(productUUID, selectedRole, selectedOption, selectedOrientation)
      .then((result) => {
        const { nodes: newNodes, edges: newEdges } = result.data;

        setNodes([ ...newNodes ]);
        // setEdges([ ...newEdges ]);
      })
      .catch((err) => {
        setNodes([]);
        // setEdges([]);
      });
  }

  useEffect(() => {
    setNodes([]);
    // setEdges([]);

    if (!props?.isOpen) return;
    if (!selectedOption?.cost_id || !productUUID || !selectedRole) return;

    getDataWithCalculations(productUUID, selectedRole, selectedOption?.cost_id, selectedOrientation);
  }, [props.isOpen, selectedOption?.cost_id, selectedOrientation, selectedRole])

  useEffect(() => {
    if (nodes?.[0]?.data?.nodeData?.pricingData?.promotion) {
      setIsPromoFlowAvailable(true);
      return;
    }

    setIsPromoFlowAvailable(false);
    setIsPromoFlow(false);
  }, [nodes])

  function handleNodeFilter(n) {
    const pricingType = isPromoFlow ? 'promotion' : 'standard';
    const isPriceOverriden = n.data.nodeData.pricingData?.[pricingType]?.isPriceOverriden;
    const wasValueAppliedUsed = n.data.nodeData.pricingData?.[pricingType]?.formulaEval?.wereValuesUsed;

    return n.data.nodeData.pricingData && ((!isPriceOverriden && !!wasValueAppliedUsed) || ['start', 'end'].includes(n.data.id));
  }

  return (
    <Modal
      open={props?.isOpen || false}
      onClose={props?.onClose}
      aria-labelledby="calculation flow modal"
      aria-describedby="modal to show the steps for a calculation flow"
      style={{marginTop: '100px'}}
    >
      <Paper style={{padding: "20px 15px", position: "absolute", top: "50%", left: "50%", width: "80vw", maxHeight: "800px", maxWidth: "600px", transform: `translate(-50%, -50%)`}}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl size="small" variant="filled" style={{width: "100%", maxWidth: "300px"}}>
              <InputLabel shrink id="option-list-label">Selected Option</InputLabel>
              <Select
                value={selectedOption?.cost_id ?? ""}
                onChange={(e) => {
                  const option = props.options?.find(option => option.cost_id === e.target.value);

                  setSelectedOption({ ...option });
                }}        
                variant="filled"
                displayEmpty
              >
                <MenuItem value={""} disabled>
                  Please select one of the following options
                </MenuItem> 
                { 
                  props.options?.map(option => {

                    let optionDetails = "";

                    if (option.retail_price) {
                      optionDetails = "$" + option.retail_price?.toFixed(2);
                    }

                    if (option.is_promo_active) {
                      optionDetails = "$" + option.promotion_pricing.retail_price?.toFixed(2) + " (Promo)";
                    }

                    if (option.is_discontinued) {
                      optionDetails = "Discontinued";
                    } else if (option.is_ask_for_price) {
                      optionDetails = "Ask For Price";
                    } else if (option.is_call_for_price) {
                      optionDetails = "Call For Price";
                    }

                    if (option.uom) {
                      optionDetails += optionDetails !== "" ? ` - ${option.uom}` : option.uom;
                    }

                    if (option.basis_cd) {
                      optionDetails += optionDetails !== "" ? ` - ${option.basis_cd}` : option.basis_cd;
                    }

                    return (
                      <MenuItem key={option.cost_id} value={option.cost_id}>
                        <Typography variant="body2" color={option.is_discontinued ? "error" : "inherit"}>
                          <b>{option.color_name}</b>
                          <br></br>
                          {option.distributor}
                          <br></br>
                          <span style={{color: option.is_promo_active ? "#f44336" : "inherit"}}>{optionDetails}</span>
                        </Typography>
                      </MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>
          </Grid>
          { isPromoFlowAvailable && (
            <Grid item xs={12}>
              <ToggleButtonGroup
                value={isPromoFlow?.toString()}
                exclusive
                size='small'
                onChange={(e, newValue) => {
                  if (newValue === null) return;

                  setIsPromoFlow(JSON.parse(newValue))
                }}
                aria-label="text alignment"
              >
                <ToggleButton value='false' aria-label="Standard" style={!isPromoFlow ? {backgroundColor: "#142E3E", color: "#28C4FC"} : {backgroundColor: "#00000017", color: "initial"}}>
                  Standard
                </ToggleButton>
                <ToggleButton value='true' aria-label="Promotion" style={isPromoFlow ? {backgroundColor: "#142E3E", color: "#28C4FC"} : {backgroundColor: "#00000017", color: "initial"}}>
                  Promotion
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
          )}
          {
            nodes?.[0]?.data?.nodeData?.pricingData?.[isPromoFlow ? 'promotion' : 'standard']?.isPriceOverriden ? (
              <Grid item xs={12}>
                <Typography variant="caption" component="div">
                  This price has an override present and therefore does not go through the full calculation flow. This override is present due to one of the following cases
                  <Typography variant="inherit" component="ul" style={{marginTop: "1em"}}>
                    <Typography variant="inherit" component="li">You are importing pricing data from an ERP system and are using the calculations from that system</Typography>
                    <Typography variant="inherit" component="li">You have set this in a manual import file</Typography>
                    <Typography variant="inherit" component="li">You have added a temporary retail price override for this option on the product search page</Typography>
                    <Typography variant="inherit" component="li">You have requested that we add a specialty override on our end</Typography>
                  </Typography>
                </Typography>
              </Grid>
            ) : undefined
          }
          <Grid item xs={12} style={{overflowY: "auto", maxHeight: "500px", marginTop: "10px"}}>
            {!nodes?.length ? (
              <Typography component="div" style={{textAlign: "center", height: "300px"}}>
                <CircularProgress size={100} style={{display: "block", margin: "50% auto 10px"}} />
                <b>Loading...</b>
              </Typography>
            ) : undefined}
            {nodes?.filter(handleNodeFilter)?.sort((a, b) => a.level.x - b.level.x).map(n => {
              const pricingData = n.data.nodeData.pricingData[isPromoFlow ? 'promotion' : 'standard'];
              const nodeResult = pricingData.formulaEval?.result || pricingData.value || null;

              if (props.user?.user_id && props.user?.is_hidden) {
                return (
                  <Accordion style={{margin: "10px auto"}} key={n.id}>
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1a-content"
                      style={{backgroundColor: "#00000017"}}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Typography>{n.data.label}</Typography>
                          {n.data.nodeData.formula ? (
                              <Typography variant="caption" style={{display: 'block'}}>
                                Used the <u>{n.data.nodeData.formula}</u> formula with value <u>{pricingData.formulaEval?.valueAdded}</u>
                              </Typography> 
                            ) : undefined
                          }
                          <Typography variant="subtitle2" style={{display: 'block', marginTop: "10px"}}>{nodeResult ? 'Output: $' + nodeResult : ''}</Typography>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails>
                      <pre>{JSON.stringify(pricingData, null, 2)}</pre>
                    </AccordionDetails>
                  </Accordion>
                )
              }

              return (
                <div style={{margin: "10px auto"}} key={n.id}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} style={{backgroundColor: "#00000017", borderRadius: "5px", margin: "3px auto"}}>
                      <Typography>{n.data.label}</Typography>
                      {n.data.nodeData.formula ? (
                          <Typography variant="caption" style={{display: 'block'}}>
                            Used the <u>{n.data.nodeData.formula}</u> formula with value <u>{pricingData.formulaEval?.valueAdded}</u>
                          </Typography> 
                        ) : undefined
                      }
                      <Typography variant="subtitle2" style={{display: 'block', marginTop: "10px"}}>{nodeResult ? 'Output: $' + nodeResult : ''}</Typography>
                    </Grid>
                  </Grid>
                </div>
              )
            })}
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" onClick={props.onClose} style={{marginTop: "10px", float: "right"}}>
              Close
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  )
}